import React, {useState} from 'react';
import '../Footer/Footer2.css';
import { Link } from 'react-router-dom';
import Icard from '../Icard/Icard';
const Footer2 = () => {
    const [isIcardOpen, setIsIcardOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const openIcard = () => {
    setIsIcardOpen(true);
  };

  const closeIcard = () => {
    setIsIcardOpen(false);
  };
  return (
    <>
      <footer className="footer-n">
      {isIcardOpen && <Icard onClose={closeIcard} />}
        <ul className="footer-links-n">
          <li><Link to="/">Home</Link></li>
          <li><Link to="/aboutus">About</Link></li>
          <li><Link to="/layouts">Layouts</Link></li>
          <li><Link to="/pricelist">Price List</Link></li>
          <li><a href="#" onClick={openIcard} >Brochure</a></li>
          <li><Link to="/contactus">Contact</Link></li>
        </ul>
        <hr className="footer-divider-n" />
        <div className="footer-bottom-n">
          <p className="bot-p">
            &copy; {currentYear} Pan Oasis | All Rights Reserved {' '}
           
           
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer2;
